import { Competency, LearnerOutcome } from "@/lib/models";
import Image from "next/image";

type OverviewListCompetencyButtonProps = {
  handleEntityClick: (entity: Competency | LearnerOutcome) => void;
  competency: Competency;
  selectedEntity: Competency | LearnerOutcome | null;
  searchResultIds: string[];
  learnerOutcomeId: string;
};

export const OverviewListCompetencyButton = ({
  handleEntityClick,
  competency,
  selectedEntity,
  searchResultIds,
  learnerOutcomeId,
}: OverviewListCompetencyButtonProps) => {
  const isSearchApplied = searchResultIds?.length > 0;
  const isInSearchResults = searchResultIds?.includes(competency.id);
  const isSelectedEntity = selectedEntity?.id === competency.id;

  let opacity = "opacity-100";

  if (isSearchApplied && !isInSearchResults && !isSelectedEntity) {
    opacity = "opacity-20 bg-white";
  }

  const colorStyles = () => {
    if (!isSearchApplied && !isSelectedEntity) {
      return "bg-default-bg-color border-tab-border";
    }

    if (isSelectedEntity) {
      return `border-${learnerOutcomeId}-60 bg-${learnerOutcomeId}-40`;
    }

    if (isSearchApplied && isInSearchResults && !isSelectedEntity) {
      return `border-${learnerOutcomeId}-40 bg-${learnerOutcomeId}-20`;
    }
  };

  return (
    <button
      aria-label={competency.name}
      key={competency.id}
      onClick={() => handleEntityClick(competency)}
      className={`flex items-center justify-start whitespace-normal rounded-full border py-2 pl-4 pr-6 transition duration-200 hover:opacity-100 hover:drop-shadow-lg active:opacity-100 ${opacity} active:border-${learnerOutcomeId}-60 active:bg-${learnerOutcomeId}-40 ${colorStyles()}`}
    >
      {competency.icon.sourceUrl && (
        <Image
          src={competency.icon.sourceUrl}
          alt=""
          width={48}
          height={56}
          className="h-[56px] w-[48px]"
        />
      )}
      <div className="ml-2 font-roobert text-sm font-medium leading-none text-black">
        {competency.name}
      </div>
    </button>
  );
};
